(function() {
  'use strict';

  function initWavyBand() {
    const sections = document.querySelectorAll('.wcb');
    
    sections.forEach(section => {
      const textPath = section.querySelector('.wcb__textPath');
      if (!textPath) return;

      const speed = parseFloat(textPath.dataset.speed) || 35;
      
      let offset = 0;
      let animationFrame;
      let lastTime = performance.now();

      function getTextLength() {
        const textElement = textPath.parentElement;
        if (textElement && textElement.getComputedTextLength) {
          return textElement.getComputedTextLength();
        }
        return 3000;
      }

      function animate(currentTime) {
        const deltaTime = currentTime - lastTime;
        lastTime = currentTime;

        offset += deltaTime / speed;

        const textLength = getTextLength();
        
        if (offset > textLength) {
          offset = 0;
        }

        textPath.setAttribute('startOffset', `${offset}px`);

        animationFrame = requestAnimationFrame(animate);
      }

      animationFrame = requestAnimationFrame(animate);

      window.addEventListener('beforeunload', () => {
        if (animationFrame) {
          cancelAnimationFrame(animationFrame);
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWavyBand);
  } else {
    initWavyBand();
  }

  document.addEventListener('shopify:section:load', initWavyBand);
})();